export enum OrdersPageView {
  OrdersList,
  UnassignedDocuments,
}
